import React, {useEffect, useRef} from 'react'
import styled from 'styled-components'

const Entry = styled.div`
    font-size: 16px;
    padding: 6px 16px;
    color: #4a4a4a;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
	line-height: 1.5;
    background-color: ${props => props.focus ? 'rgba(0, 0, 0, 0.04)' : 'rgba(255, 255, 255, 1)'};
`

export default (props) => {
	const {mention, isFocused, onMouseUp, onMouseDown, onMouseEnter, id} = props
	const entryRef = useRef(null)

	useEffect(() => {
		if (isFocused) {
			if ("scrollIntoViewIfNeeded" in document.body) {
				entryRef.current.scrollIntoViewIfNeeded(false)
			} else {
				entryRef.current.scrollIntoView(false)
			}
		}
	}, [isFocused])

	return (
		<Entry
			focus={isFocused}
			id={id}
			ref={entryRef}
			role="option"
			aria-selected={isFocused ? "true" : "false"}
			onMouseUp={onMouseUp}
			onMouseEnter={onMouseEnter}
			onMouseDown={onMouseDown}
		>
			{mention.name}
		</Entry>
	)
}
